const decodeBase64Url = (input) => {
  const normalized = String(input ?? '')
    .replace(/-/g, '+')
    .replace(/_/g, '/')
  const padding = normalized.length % 4
  const padded = normalized + (padding ? '='.repeat(4 - padding) : '')

  if (typeof atob === 'function') {
    return decodeURIComponent(
      Array.from(atob(padded))
        .map((character) => `%${character.charCodeAt(0).toString(16).padStart(2, '0')}`)
        .join(''),
    )
  }

  if (typeof globalThis !== 'undefined' && typeof globalThis.Buffer !== 'undefined') {
    return globalThis.Buffer.from(padded, 'base64').toString('utf8')
  }

  throw new Error('Base64 decoding is not supported in this environment.')
}

const safeJsonParse = (value) => {
  try {
    return JSON.parse(value)
  } catch (error) {
    console.warn('[jwt-decode] Failed to parse payload:', error)
    return {}
  }
}

const decodeSection = (token, index) => {
  if (!token || typeof token !== 'string') {
    throw new Error('Invalid JWT provided')
  }
  const parts = token.split('.')
  if (parts.length <= index) {
    throw new Error('Malformed JWT')
  }
  return safeJsonParse(decodeBase64Url(parts[index]))
}

const jwtDecode = (token, options = {}) => {
  const payload = decodeSection(token, 1)
  if (options.header) {
    return { header: decodeSection(token, 0), payload }
  }
  return payload
}

jwtDecode.default = jwtDecode
jwtDecode.jwtDecode = jwtDecode
jwtDecode.decode = jwtDecode
jwtDecode.version = 'local-1.0.0'

export default jwtDecode
export { jwtDecode }
